// Centralized constants for PatTrak
// Extracted from various components for enterprise-grade code organization

// CPC Section codes (A-H, Y)
export const CPC_SECTIONS = {
  'A': 'Human Necessities',
  'B': 'Performing Operations; Transporting',
  'C': 'Chemistry; Metallurgy',
  'D': 'Textiles; Paper',
  'E': 'Fixed Constructions',
  'F': 'Mechanical Engineering; Lighting; Heating; Weapons',
  'G': 'Physics',
  'H': 'Electricity',
  'Y': 'Cross-sectional Technologies'
};

// Detailed CPC code definitions with subsections
export const CPC_DEFINITIONS = {
  'A': 'Human Necessities',
  'A01': 'Agriculture; Forestry',
  'A61': 'Medical or Veterinary Science',
  'A61K': 'Preparations for Medical, Dental or Toiletry Purposes',
  'B': 'Operations; Transport',
  'C': 'Chemistry; Metallurgy',
  'C01': 'Inorganic Chemistry',
  'C01B': 'Non-metallic Elements; Compounds',
  'D': 'Textiles; Paper',
  'E': 'Fixed Constructions',
  'F': 'Mechanical Engineering',
  'G': 'Physics',
  'G06': 'Computing; Calculating; Counting',
  'G06F': 'Electric Digital Data Processing',
  'G06N': 'Computing Arrangements Based on Specific Computational Models (AI/Machine Learning)',
  'G16': 'Information and Communication Technology',
  'H': 'Electricity',
  'H01': 'Basic Electric Elements',
  'H01M': 'Processes or Means for the Direct Conversion of Chemical Energy into Electrical Energy (Batteries)',
  'H02': 'Generation; Conversion or Distribution of Electric Power',
  'H02J': 'Circuit Arrangements for AC or DC Mains for Charging',
  'H04': 'Electric Communication Technique',
  'Y': 'Emerging Cross-Sectional Technologies',
  'Y02': 'Technologies or Applications for Mitigation or Adaptation Against Climate Change',
  'Y02E': 'Reduction of Greenhouse Gas Emissions, Related to Energy Generation, Transmission or Distribution'
};
